/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CognitoStrictHttpResponse } from '../../cognito-strict-http-response';
import { CognitoRequestBuilder } from '../../cognito-request-builder';

import { CognitoMessageResponseDto } from '../../models/cognito-message-response-dto';

export interface CognitoControllerEnableUser$Params {

/**
 * The tenant identifier
 */
  tenant: string;

/**
 * The ID (sub) of the user to enable
 */
  id: string;
}

export function cognitoControllerEnableUser(http: HttpClient, rootUrl: string, params: CognitoControllerEnableUser$Params, context?: HttpContext): Observable<CognitoStrictHttpResponse<CognitoMessageResponseDto>> {
  const rb = new CognitoRequestBuilder(rootUrl, cognitoControllerEnableUser.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CognitoStrictHttpResponse<CognitoMessageResponseDto>;
    })
  );
}

cognitoControllerEnableUser.PATH = '/o2-cognito/cognito/users/{tenant}/{id}/enable';
